import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
  selector: 'elm-progress-spinner',
  templateUrl: './elm-progress-spinner.component.html',
  styleUrls: ['./elm-progress-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ElmProgressSpinnerComponent {
  @Input() value!: number;
  @Input() bufferValue = 100;
  @Input() color: ThemePalette = 'primary';
  @Input() mode: ProgressSpinnerMode = 'determinate';
  @Input() size: 'small' | 'medium' | 'large' | 'x-large' = 'medium';
  private _diameter!: number;
  private _strokeWidth!: number;

  @Input()
  set diameter(value: number) {
    this._diameter = value;
  }
  get diameter() {
    if (this._diameter) return this._diameter;

    switch (this.size) {
      case 'small':
        return 32;

      case 'large':
        return 64;

      case 'x-large':
        return 128;
    }

    return 44;
  }

  @Input()
  set strokeWidth(value: number) {
    this._strokeWidth = value;
  }
  get strokeWidth() {
    if (this._strokeWidth) return this._strokeWidth;

    switch (this.size) {
      case 'small':
        return 1;

      case 'large':
        return 4;

      case 'x-large':
        return 6;
    }

    return 2;
  }

  get percentage() {
    return this.value ? Math.round((this.value / this.bufferValue) * 100) : 0;
  }
}
